import { HttpError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import SchedulingPage, { SchedulingPageDto } from "./SchedulingPage"


class SchedulingPageService {
    httpClient: HttpClient<SchedulingPage, SchedulingPageDto> = new HttpClient<SchedulingPage, SchedulingPageDto>(SchedulingPage)

    async updateCustomFields(
        schedulingPageId: string,
        integrationKey: string,
        customFieldDefinitionIds: string[]
    ): Promise<SchedulingPage | HttpError> {
        const res = await this.httpClient.patch(`/${integrationKey}/scheduling-pages/${schedulingPageId}/custom-fields`, {
            schedulingPageId : schedulingPageId,
            customFieldDefinitionIds: customFieldDefinitionIds,
        })
        return res
    }
}

const instance = new SchedulingPageService()
export default instance


// WEBPACK FOOTER //
// ./src/state/scheduling-page/SchedulingPageService.ts